import httpCommon from "./http-common";

// Get all workflows
const getAllWorkflows = (businessId: number) => {
  return httpCommon.get(`/v1/get/workflows/${businessId}`);
};

// Get workflow by ID
const getWorkflow = (workflowId: string) => {
  return httpCommon.get(`/v1/get/workflow/${workflowId}`);
};

// Create workflow
const createWorkflow = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/workflow/${businessId}`, data);
};

// Update workflow
const updateWorkflow = (workflowId: number, data: any) => {
  return httpCommon.put(`/v1/update/workflow/${workflowId}`, data);
};

// Delete workflow
const deleteWorkflow = (workflowId: number) => {
  return httpCommon.delete(`/v1/delete/workflow/${workflowId}`);
};

// Enable workflow
const enableWorkflow = (workflowId: number) => {
  return httpCommon.put(`/v1/enable/workflow/${workflowId}`);
};

// Disable workflow
const disableWorkflow = (workflowId: number) => {
  return httpCommon.put(`/v1/disable/workflow/${workflowId}`);
};

// Get workflow logs
const getWorkflowLogs = (workflowId: number) => {
  return httpCommon.get(`/v1/get/workflow-logs/${workflowId}`);
};

const WorkflowService = {
  getAllWorkflows,
  getWorkflow,
  createWorkflow,
  updateWorkflow,
  deleteWorkflow,
  enableWorkflow,
  disableWorkflow,
  getWorkflowLogs
};

export default WorkflowService; 